<template>
    <div id="Statistical_Into">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>分成统计</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="box-card">
            <el-form ref="form" :model="form" label-width="80px" :inline="true" size="small">
                <el-form-item label="">
                    <el-col :span="11">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="开始日期" v-model="form.time1"
                                            value-format="yyyy-MM-dd"
                                            style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1">-</el-col>
                    <el-col :span="11">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="结束日期" v-model="form.time2"
                                            value-format="yyyy-MM-dd"
                                            style="width: 100%;" @change="changeClick"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="created_at"
                        label="日期">
                </el-table-column>
                <el-table-column
                        prop="sn"
                        label="订单号">
                </el-table-column>
                <el-table-column
                        prop="mch.title"
                        label="返佣代理">
                </el-table-column>
                <el-table-column
                        prop="mch.lv"
                        label="代理佣金比例">
                </el-table-column>
                <el-table-column
                        prop="type"
                        label="充值类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==1">普通充值</span>
                        <span v-if="scope.row.type==2">VIP充值</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="level"
                        label="所属层级">
                </el-table-column>
                <el-table-column
                        prop="money"
                        label="分成金额">
                </el-table-column>
            </el-table>
            <div class="el-pagination">
                <el-pagination
                        background
                        @size-change="changeSize"
                        @current-change="changeCurrent"
                        :current-page="params.pagenum"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="params.pagesize"
                        :layout="this.$store.state.paginationLayout"
                        :total="params.totals">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
    import {formatDate} from '../../utils/common'

    export default {
        name: "Statistical_Into",
        data() {
            return {
                params: {
                    pagenum: 1,
                    pagesize: 10,
                    totals: 0
                },
                form: {
                    time1: '',
                    time2: ''
                },
                tableData: [],
                fromTitle: '',
                visible: false,
                imageUrl: '',
                activeName: 'first'
            }
        },
        created() {
            this.getList();
        },
        methods: {
            changeClick(e) {
                if (e < this.form.time1) {
                    this.$message.error('结束日期不能小于开始日期');
                    this.form.time2 = '';
                }
            },
            getList() {
                let data = {
                    page: this.params.pagenum,
                    page_size: this.params.pagesize,
                    start_time: this.form.time1,
                    end_time: this.form.time2
                };
                this.$axios.post("mch/separate/base_info", data).then((res) => {
                    this.params.totals = res.data.count;
                    this.tableData = res.data.list;
                });
            },
            // 每页显示多少条
            changeSize(val) {
                this.params.pagesize = val;
                this.getList();
            },
            // 当前显示的页数
            changeCurrent(val) {
                this.params.pagenum = val;
                this.getList();
            },
            search() {
                this.params.pagenum = 1;
                this.getList();
            }
        }
    }
</script>

<style scoped>

</style>